import React, { createContext, useState, useCallback, useMemo } from 'react';
import useWebSocket from 'react-use-websocket';
import { ACCESS_TOKEN } from '../utils/constants';
import { getLocalStorage } from '../utils/localStorage';
import { WS_URL } from '../config/constant';

export const WebSocketContext = createContext(null);
export const NewItemCounterContext = createContext({});
export const NotificationContext = createContext({
  notifications: [],
  hasNewNotifications: false,
  updateHasNewNotifications: () => {}
});

export function WebSocketProvider ({ children }) {
  const [itemNumber, setItemNumber] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [hasNewNotifications, setHasNewNotifiations] = useState(false);

  const { sendMessage, getWebSocket } = useWebSocket(`${WS_URL}/OpenCashWebSocket`,
  {
    onOpen: () => {
      const token = getLocalStorage(ACCESS_TOKEN);
      if (token) {
        sendMessage(`{"type":"authentification","token":"${token}"}`);
      }
    },
    shouldReconnect: () => true,
    onMessage: event => {
      const eventData = JSON.parse(event.data);
      const { type } = eventData;
      let data;
      try {
        data = JSON.parse(eventData.data);
      } catch (e) {
        return;
      }

      if (type === 'notification') {
        const newNotifications = [...notifications];
        data.notification?.forEach(notif => {
          if (newNotifications.findIndex(({ notification_id }) => notification_id === notif.notification_id) === -1) {
            newNotifications.push(notif);
          }
        });
        setHasNewNotifiations(data.new_notification);
        setNotifications(newNotifications);
        return;
      }

      if (type === 'read_notification') {
        const newNotifications = [...notifications];
        data.notification?.forEach(notif => {
          const index = newNotifications.findIndex(({ notification_id }) => notification_id === notif.notification_id);
          if (index !== -1) {
            newNotifications[index] = notif;
          }
        });
        setNotifications(newNotifications);
        return;
      }

      setItemNumber(i => ({ ...i, [data.autorisation]: { number: data.number, color: data.color } }));
    }
  });

  const updateHasNewNotifications = useCallback((value) => {
    setHasNewNotifiations(value);
  }, []);

  const clearAll = useCallback(() => {
    setNotifications([]);
  }, []);

  return (
    <WebSocketContext.Provider
      value={getWebSocket}
    >
      <NewItemCounterContext.Provider
        value={itemNumber}
      >
        <NotificationContext.Provider
          value={useMemo(() => ({
            notifications,
            hasNewNotifications,
            updateHasNewNotifications,
            clearAll
          }), [notifications, hasNewNotifications, updateHasNewNotifications, clearAll])}
        >
          {children}
        </NotificationContext.Provider>
      </NewItemCounterContext.Provider>
    </WebSocketContext.Provider>);
}